/* eslint-disable no-undef */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */
import {
    DeleteOutlined,
    EditOutlined
} from '@ant-design/icons';
import {
    Col,
    Form,
    Modal,
    Pagination,
    Row,
    Select,
    Space
} from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/button';
import Icon from '../../components/icon';
import Input from '../../components/input';
import Spinner from '../../components/spinner';
import Table from '../../components/table';
import { createDevice, deleteDevice, getDevices, getTypesDevices, updateDevice } from '../../redux/actions/device';
import { getAllEstablishments } from '../../redux/actions/establishment';

const { Item } = Form;
const { Option } = Select;

const columns = [
    {
        title: 'Nombre',
        dataIndex: 'nombre',
        key: 'nombre'
    },
    {
        title: 'Tipo de Dispositivo',
        dataIndex: ['deviceType', 'name'],
        key: 'tipoDispositivo'
    },
    {
        title: 'Establecimiento',
        dataIndex: ['establishment', 'nombre'],
        key: 'establecimiento',
        render: (text, record) => {
            return record.establishment?.nombre || 'No asignado';
        }
    }
];

const DevicesPage = () => {
    const dispatch = useDispatch();
    const rol = localStorage.getItem('rol');
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;
    const [showModalNew, setShowModalNew] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [selectedDevice, setSelectedDevice] = useState(null);
    const [form] = Form.useForm();
    const [sensorTypes, setSensorTypes] = useState([]);
    const { establishments } = useSelector((state) => state.establishmentReducer);
    const { deviceTypes } = useSelector((state) => state.device);

    // Estado de Redux
    const state = useSelector((state) => state.device);
    const dataSource = useMemo(() => state?.devices?.data || [], [state]);
    const isLoading = useMemo(() => state?.isLoading || false, [state]);

    // Calcular datos paginados
    const paginatedData = useMemo(() => {
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        return dataSource.slice(startIndex, endIndex);
    }, [dataSource, currentPage]);

    // Manejador de cambio de página
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    console.log('sensorTypes', sensorTypes);
    useEffect(() => {
        dispatch(getDevices());
        dispatch(getAllEstablishments());
        dispatch(getTypesDevices())
            .then((response) => {
                // Accedemos a response.payload.data que es donde están los tipos de sensores
                if (response.payload && response.payload.data) {
                    setSensorTypes(response.payload.data);
                }
            })
            .catch((error) => {
                console.error('Error al obtener tipos de sensores:', error);
            });
    }, [dispatch]);

    const openModal = () => {
        setShowModalNew(true);
    };

    const closeModal = () => {
        setShowModalNew(false);
        setShowModalEdit(false);
        setSelectedDevice(null);
        form.resetFields();
    };

    const handleDelete = (id) => {
        dispatch(deleteDevice(id, () => {
            dispatch(getDevices());
        }));
    };

    const handleEdit = (record) => {
        setSelectedDevice(record);
        form.setFieldsValue({
            nombre: record.nombre,
            tipoDispositivo: record.deviceType._id,
            establishment: record.establishment._id
        });
        setShowModalEdit(true);
    };

    const handleSubmit = () => {
        form.validateFields().then((values) => {
            const deviceData = {
                nombre: values.nombre,
                tipoDispositivo: values.tipoDispositivo,
                establishment: values.establishment
            };

            if (selectedDevice) {
                dispatch(updateDevice(selectedDevice._id, deviceData, () => {
                    closeModal();
                    dispatch(getDevices());
                }));
            } else {
                dispatch(createDevice(deviceData, () => {
                    closeModal();
                    dispatch(getDevices());
                }));
            }
        }).catch((error) => {
            console.error('Error en la validación:', error);
        });
    };

    const actionsColumn = (record) => (
        <Space size="middle">
            <Button
                type="primary"
                icon={<EditOutlined />}
                color="transparent"
                text="Editar"
                onClick={() => handleEdit(record)}
            />
            <Button
                type="primary"
                icon={<DeleteOutlined />}
                color="transparent"
                text="Eliminar"
                onClick={() => handleDelete(record._id)}
            />
        </Space>
    );

    const renderForm = () => (
        <Form form={form} layout="vertical">
            <Row gutter={16}>
                <Col span={24}>
                    <Item
                        name="nombre"
                        label="Nombre"
                        rules={[{ required: true, message: 'Por favor ingrese el nombre' }]}
                    >
                        <Input />
                    </Item>
                </Col>
            </Row>
            <Item
                name="tipoDispositivo"
                label="Tipo de Dispositivo"
                rules={[{ required: true, message: 'Por favor seleccione el tipo' }]}
            >
                <Select placeholder="Seleccione un tipo">
                    {deviceTypes && deviceTypes.map((type) => (
                        <Option key={type._id} value={type._id}>
                            {type.name}
                        </Option>
                    ))}
                </Select>
            </Item>
            <Item
                name="establishment"
                label="Establecimiento"
                rules={[{ required: true, message: 'Por favor seleccione el establecimiento' }]}
            >
                <Select placeholder="Seleccione un establecimiento">
                    {establishments?.map(est => (
                        <Option key={est._id} value={est._id}>
                            {est.nombre}
                        </Option>
                    ))}
                </Select>
            </Item>
            <Item style={{ textAlign: 'center', marginTop: '20px' }}>
                <Button type="primary" onClick={handleSubmit} text="Guardar" />
            </Item>
        </Form>
    );

    return (
        <div className="container-page__box">
            <div
                className="container-page__header"
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '24px 28px'
                }}
            >
                <div className="container-page__title">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Icon
                            name="Home"
                            size={64}
                        />
                        <div style={{
                            marginLeft: '10px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            height: '64px'
                        }}>
                            <h1 style={{
                                margin: 0,
                                fontSize: '24px',
                                color: '#306A59'
                            }}>
                                Dispositivos
                            </h1>
                            <div
                                style={{
                                    width: '50%',
                                    height: '8px',
                                    backgroundColor: '#306A59'
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="container-page__actions">
                    {rol === 'superadmin' && (
                        <Button
                            text={(
                                <>
                                    <span style={{ textDecoration: 'underline' }}>Agregar dispositivo</span>
                                    {' +'}
                                </>
                            )}
                            color="transparent"
                            onClick={openModal}
                        />
                    )}
                </div>
            </div>
            <div className="container-page__table" style={{ padding: '0 28px' }}>
                {isLoading ? (
                    <Spinner />
                ) : (
                    <>
                        <Table
                            columns={columns}
                            dataSource={paginatedData}
                            actionsColumn={actionsColumn}
                            actions={rol === 'superadmin'}
                        />
                        <div className="container-page__pagination">
                            <Pagination
                                current={currentPage}
                                onChange={handlePageChange}
                                total={dataSource.length}
                                pageSize={pageSize}
                            />
                        </div>
                    </>
                )}
            </div>
            <Modal
                title="Crear nuevo Dispositivo"
                open={showModalNew}
                onOk={closeModal}
                onCancel={closeModal}
                footer={null}
            >
                {renderForm()}
            </Modal>
            <Modal
                title="Editar Dispositivo"
                open={showModalEdit}
                onOk={closeModal}
                onCancel={closeModal}
                footer={null}
            >
                {renderForm()}
            </Modal>
        </div>
    );
};

export default DevicesPage;
